module.exports = __webpack_public_path__ + "img/download_ic.d96eb117.png";